import React, { Component } from 'react';
import {
    FaEdit,
    FaEye
} from "react-icons/fa";
import { Link } from 'react-router-dom';
import Layout from './../layouts/Index';
import { connect } from 'react-redux';
import Moment from 'react-moment';
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Row, Col, Container, ListGroup, Button, Placeholder } from 'react-bootstrap';
import { showMoq } from './../../store/actions/MoqActions';
import { formatPrice, renderMoqAttributes} from "../../utils/index";

class Show extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            privilege: 0
        };
    }

    componentDidMount = async () => {
        const { match: { params } } = this.props;

        this.setState({ loading: true, edge: parseInt(localStorage.getItem('ltdn_priv')) });

        const result = await this.props.showMoq(params.id);

        if (result) {
            this.setState({ loading: false });
        }
    };

    render() {
        const { moqs: { moq } } = this.props;
        const { loading } = this.state;

        const isValidUrl = (str) => {
            try {
                new URL(str);
                return true;
            } catch (_) {
                return false;
            }
        };

        // placeholder button style to mimic small buttons
        const placeholderBtnStyle = { height: 32, borderRadius: 6 };

        return (
            <Layout>
                <Col sm="12" style={{ minHeight: '80vh', padding: '1.5em 0' }}>
                    <Container>
                        <Row>
                            {/* Header */}
                            <Col sm="12" className="d-flex justify-content-between align-items-center mb-3">
                                {loading ? (
                                    <Placeholder as="h3" animation="wave">
                                        <Placeholder xs={4} />
                                    </Placeholder>
                                ) : (
                                    moq && moq.product?.[0] && (
                                        <h3>
                                            <Link to={`/admin/products/${moq.product[0].id}`}>
                                                        {moq.product[0].name}
                                                    </Link>{" - "}
                                            MOQ #{moq.moq_number}
                                        </h3>
                                    )
                                )}
                            </Col>

                            {/* Product Image */}
                            <Col sm="4" className="mb-3 d-flex align-items-stretch">
                                {loading ? (
                                    <Placeholder
                                        as="div"
                                        animation="wave"
                                        className="w-100 h-100"
                                        style={{ minHeight: "400px" }}
                                    >
                                    <Placeholder xs={4} className="h-100 w-100" />
                                    </Placeholder>
                                ) : (
                                    Array.isArray(moq.product) &&
                                    moq.product.length > 0 &&
                                    moq.product[0].images.length > 0 && (
                                    <LazyLoadImage
                                        src={moq.product[0].images[0]}
                                        alt={moq.product[0].name}
                                        effect="opacity"   // 👈 Smooth fade-in
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            minHeight: "400px",
                                            objectFit: "cover",
                                            borderRadius: "0.25rem",
                                            transition: "opacity 0.5s ease-in-out", // optional extra smoothness
                                        }}
                                    />
                                    )
                                )}
                            </Col>
                            {/* Product Content */}
                            <Col sm="8">
                                {loading ? (
                                    <ListGroup>
                                        {[...Array(8)].map((_, idx) => (
                                            <ListGroup.Item key={idx}>
                                                <Placeholder as="p" animation="wave">
                                                    <Placeholder xs={8} /> <Placeholder xs={4} />
                                                </Placeholder>
                                            </ListGroup.Item>
                                        ))}
                                        {/* Placeholder buttons that match small button height */}
                                        <ListGroup.Item className="d-flex gap-2">
                                            <Placeholder.Button variant="success" xs={3} style={placeholderBtnStyle} />
                                            <Placeholder.Button variant="warning" xs={3} style={placeholderBtnStyle} />
                                            <Placeholder.Button variant="primary" xs={3} style={placeholderBtnStyle} />
                                        </ListGroup.Item>
                                    </ListGroup>
                                ) : (
                                    <ListGroup>
                                        {(localStorage.getItem("ltdn_priv") === "2" || moq.creator === true) && (
                                            <ListGroup.Item>
                                                <span className="fw-bold">Sourced From: </span>
                                                {moq.source && isValidUrl(moq.source) ? (
                                                    <a href={moq.source} target="_blank" rel="noopener noreferrer">
                                                        Open Source Link
                                                    </a>
                                                ) : (
                                                    <span>{moq.source}</span>
                                                )}
                                            </ListGroup.Item>
                                        )}

                                        <ListGroup.Item>
                                            <span className="fw-bold">
                                                {moq.status === 1 ? "Live link: " : "Preview link: "}
                                            </span>
                                            <a href={`https://www.litudian.com/products/${moq.moq_slug}`}
                                                target="_blank" rel="noopener noreferrer">
                                                Open Merchant Platform
                                            </a>
                                        </ListGroup.Item>

                                        <ListGroup.Item>
                                            <span className="fw-bold">MOQ Price: </span>
                                            <span>{formatPrice(moq.price, moq.moq_attributes, "price")}</span>
                                        </ListGroup.Item>

                                        <ListGroup.Item>
                                            <span className="fw-bold">Below MOQ Price: </span>
                                            <span>
                                                {formatPrice(moq.below_moq_price, moq.moq_attributes, "below_moq_price")}
                                            </span>
                                        </ListGroup.Item>

                                        {(localStorage.getItem("ltdn_priv") === "2" || moq.creator === true) && (
                                            <ListGroup.Item>
                                                <span className="fw-bold">Supplier Price: </span>
                                                <span>{formatPrice(
                                                        moq.readable_supplier_price ?? moq.supplier_price,
                                                        moq.moq_attributes,
                                                        "supplier_price",
                                                        moq.supplier_currency ?? "KES",
                                                    )}
                                                </span>
                                            </ListGroup.Item>
                                        )}

                                        <ListGroup.Item>
                                            <span className="fw-bold">Target/Supplier MOQ: </span>
                                            <span>{moq.quantity}</span>
                                        </ListGroup.Item>

                                        <ListGroup.Item>
                                            <span className="fw-bold">Minimum MOQ Per Person: </span>
                                            <span>{moq.min_quantity}</span>
                                        </ListGroup.Item>

                                        <ListGroup.Item>
                                            <span className="fw-bold">Total Orders: </span>
                                            <span>{moq.total_bid_quantity}</span>
                                        </ListGroup.Item>

                                        <ListGroup.Item>
                                            <span className="fw-bold">Orders Remaining MOQ: </span>
                                            <span>{moq.moq_bid_balance}</span>
                                        </ListGroup.Item>

                                        {(localStorage.getItem("ltdn_priv") === "2" || moq.creator === true) && (
                                            <>
                                                <ListGroup.Item>
                                                    <span className="fw-bold">Total Paid Orders: </span>
                                                    <span>{moq.paid_bid_quantity}</span>
                                                </ListGroup.Item>
                                                <ListGroup.Item>
                                                    <span className="fw-bold">Total Paid Amount: </span>
                                                    <span>KES {moq.paid_bid_amount?.toLocaleString()}</span>
                                                </ListGroup.Item>
                                            </>
                                        )}
                                        <ListGroup.Item>
                                                    <span className="fw-bold">MOQ Attributes: </span>
                                                    <span>{renderMoqAttributes(moq.moq_attributes)}</span>
                                                </ListGroup.Item>
                                        <ListGroup.Item>
                                            <span className="fw-bold">Created: </span>
                                            <Moment format="LL">{moq.start_date}</Moment>
                                        </ListGroup.Item>

                                        {moq.order !== undefined && moq.moq_order_status !== "not placed" && moq.order.length > 0 && (
                                            <ListGroup.Item>
                                                <span className="fw-bold">Closed: </span>
                                                <Moment format="LL">{moq.order[0].date_created}</Moment>
                                            </ListGroup.Item>
                                        )}

                                        <ListGroup.Item>
                                            <span className="fw-bold">MOQ Status: </span>
                                            <span className={moq.status === 1 ? "text-success" : "text-danger"}>
                                                {moq.status === 1 ? "Active" : "Inactive"}
                                            </span>
                                        </ListGroup.Item>

                                        <ListGroup.Item>
                                            <span className="fw-bold">Order Status: </span>
                                            <span>{moq.moq_order_status}</span>
                                        </ListGroup.Item>

                                        <ListGroup.Item>
                                            <span className="d-flex gap-2 align-items-center">
                                                <Button
                                                    as={Link}
                                                    to={`/admin/moqs/${moq.id}/bids`}
                                                    variant="success"
                                                    size="sm"
                                                >
                                                    <FaEye className="me-1" />
                                                    View Bids
                                                </Button>

                                                {(localStorage.getItem("ltdn_priv") === "2" || moq.creator === true) &&
                                                    moq.moq_order_status === "not placed" && (
                                                        <Button
                                                            as={Link}
                                                            to={`/admin/moqs/${moq.id}/edit`}
                                                            variant="primary"
                                                            size="sm"
                                                        >
                                                            <FaEdit className="me-1" />
                                                            Edit MOQ
                                                        </Button>
                                                    )}

                                                {(localStorage.getItem("ltdn_priv") === "2" || moq.creator === true) &&
                                                    moq.moq_order_status !== "not placed" && 
                                                    Array.isArray(moq.order) && moq.order.length > 0 && (
                                                        <Button
                                                            as={Link}
                                                            to={`/admin/orders/${moq.order[0].id}`}
                                                            variant="warning"
                                                            size="sm"
                                                        >
                                                            <FaEye className="me-1" />
                                                            View Order
                                                        </Button>
                                                    )}
                                            </span>
                                        </ListGroup.Item>
                                    </ListGroup>
                                )}
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Layout>
        );
    }
};

const mapStateToProps = (state) => ({
    moqs: state.moqs,
});

export default connect(mapStateToProps, { showMoq })(Show);
